import { useEffect, useState } from "react";
import { IExeTimeDTO } from "../../../Interfaces/deltaHedgeExe";
import {
  getExeTimeInfo,
  putExeTimeInfo,
} from "../../../Requests/deltaHedgeExe";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import TimePicker from "../../../Components/TimePicker";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import Button from "../../../Components/Button";
import { toast } from "react-toastify";
import TextInput from "../../../Components/TextInput";

interface IProps {
  onClose: () => void;
}

const ExeTimeModalUI = ({ onClose }: IProps) => {
  const [exeTimeInfo, setExeTimeInfo] = useState({} as IExeTimeDTO);
  const [loading, setLoading] = useState(false);

  function convertToISO(timeString: string) {
    // Get today's date
    const today = new Date();

    // Extract year, month, and day
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(today.getDate()).padStart(2, "0");

    // Combine date with given time string
    const dateTimeString = `${year}-${month}-${day}T${timeString}`;

    // Convert to ISO format
    const isoDate = new Date(dateTimeString).toISOString();

    return isoDate;
  }

  useEffect(() => {
    setLoading(true);
    getExeTimeInfo()
      .then((resp) => {
        setExeTimeInfo({
          ...resp,
          adjustment: {
            ...resp.adjustment,
            endTimeISO: convertToISO(resp.adjustment.endTime),
            startTimeISO: convertToISO(resp.adjustment.startTime),
          },
        });
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const timeChangeHandler = (
    name: string,
    value: {
      timeString: string;
      ISOString: string | null;
    },
  ) => {
    const nameParts = name.split(".");

    setExeTimeInfo({
      ...exeTimeInfo,
      [nameParts[0]]: {
        ...exeTimeInfo[nameParts[0] as keyof IExeTimeDTO],
        [nameParts[1]]: value.timeString
          ? `${value.timeString.padStart(5, "0")}:00`
          : "",
        [nameParts[1] + "ISO"]: value.ISOString,
      },
    });
  };

  const changeHandler = (name: string, value: any) => {
    const nameParts = name.split(".");

    setExeTimeInfo({
      ...exeTimeInfo,
      [nameParts[0]]: {
        ...exeTimeInfo[nameParts[0] as keyof IExeTimeDTO],
        [nameParts[1]]: value,
      },
    });
  };

  const getFarsiProccessName = (process: string) => {
    switch (process) {
      case "adjustment":
        return "تعدیل";

      default:
        return "";
    }
  };

  const getForm = (proccessName: keyof IExeTimeDTO) => (
    <div className="flex flex-col justify-start items-start gap-2">
      {getFarsiProccessName(proccessName)}
      <div className="flex flex-row justify-start items-center gap-3 w-full">
        <TimePicker
          name={`${proccessName}.startTime`}
          onChange={timeChangeHandler}
          placeholder="شروع"
          value={exeTimeInfo[proccessName]?.startTimeISO}
        />
        <TimePicker
          name={`${proccessName}.endTime`}
          onChange={timeChangeHandler}
          placeholder="پایان"
          value={exeTimeInfo[proccessName]?.endTimeISO}
        />
      </div>
      <TextInput
        label="درصد حداقل هج در هر بار اجرا"
        name={`${proccessName}.treshold`}
        value={exeTimeInfo[proccessName]?.treshold}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label=" تاخیر اجرا(ثانیه)"
        name={`${proccessName}.delay`}
        value={exeTimeInfo[proccessName]?.delay?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <div className=" w-full flex flex-row justify-start items-center gap-3">
        <TextInput
          label="حداکثر حجم ارسالی"
          name={`${proccessName}.orderVolumeMax`}
          value={exeTimeInfo[proccessName]?.orderVolumeMax?.toString()}
          onChange={changeHandler}
          extraLabel
          kind="negativeNumbers"
        />
        <TextInput
          label="حداکثر ارزش ارسالی (ریال)"
          name={`${proccessName}.orderValueMax`}
          value={exeTimeInfo[proccessName]?.orderValueMax?.toString()}
          onChange={changeHandler}
          extraLabel
          kind="priceWithDecimal"
        />
      </div>
      <div className=" w-full flex flex-row justify-start items-center gap-3">
        <TextInput
          label="حداکثر هج(درصد)"
          name={`${proccessName}.maxHedgePercent`}
          value={exeTimeInfo[proccessName]?.maxHedgePercent?.toString()}
          onChange={changeHandler}
          extraLabel
        />
        <TextInput
          label="حداکثر هج(مقدار)"
          name={`${proccessName}.maxHedgeValue`}
          value={exeTimeInfo[proccessName]?.maxHedgeValue?.toString()}
          onChange={changeHandler}
          extraLabel
        />
      </div>
      <div className=" w-full flex flex-row justify-start items-center gap-3">
        <TextInput
          label="حداقل قیمت فروش در ورود(درصد)"
          name={`${proccessName}.minEnteringPricePercent`}
          value={exeTimeInfo[proccessName]?.minEnteringPricePercent?.toString()}
          onChange={changeHandler}
          extraLabel
        />
        <TextInput
          label="حداقل قیمت فروش در ورود(مقدار)"
          name={`${proccessName}.minEnteringPriceValue`}
          value={exeTimeInfo[proccessName]?.minEnteringPriceValue?.toString()}
          onChange={changeHandler}
          extraLabel
        />
      </div>
    </div>
  );

  const submitHandler = () => {
    setLoading(true);
    putExeTimeInfo(exeTimeInfo)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-center gap-3">
      {loading ? <FullScreenLoading /> : <></>}
      {getForm("adjustment")}

      <Button text="ثبت" onClick={submitHandler} variant="contained" />
    </div>
  );
};

export default ExeTimeModalUI;
